import { render, staticRenderFns } from "./_Registrasiuser.vue?vue&type=template&id=c9b9cd02&scoped=true"
import script from "./_Registrasiuser.vue?vue&type=script&lang=js"
export * from "./_Registrasiuser.vue?vue&type=script&lang=js"
import style0 from "./_Registrasiuser.vue?vue&type=style&index=0&id=c9b9cd02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b9cd02",
  null
  
)

export default component.exports